(function () {
  'use strict';

  /* =========================================================
     HELPERS
  ========================================================= */
  function qs(sel, ctx) { return (ctx || document).querySelector(sel); }
  function qsa(sel, ctx) { return Array.from((ctx || document).querySelectorAll(sel)); }

  /* =========================================================
     REVEAL ON SCROLL
  ========================================================= */
  function initReveal() {
    var els = qsa('.reveal');
    if (!els.length) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add('is-in');
          io.unobserve(e.target);
        }
      });
    }, { threshold: 0.12 });
    els.forEach(function (el) { io.observe(el); });
  }

  /* =========================================================
     CATEGORY TABS (Product Support)
  ========================================================= */
  function initCatTabs() {
    var tabs = qsa('.cat-tab');
    if (!tabs.length) return;
    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        var target = tab.getAttribute('data-cat');
        var container = tab.closest('[data-cat-container]') || document;
        qsa('.cat-tab', container).forEach(function (t) { t.classList.remove('active'); });
        qsa('.cat-panel', container).forEach(function (p) { p.classList.remove('active'); });
        tab.classList.add('active');
        var panel = qs('.cat-panel[data-cat-panel="' + target + '"]', container);
        if (panel) panel.classList.add('active');
      });
    });
  }

  /* =========================================================
     SKU GRID DRAG SCROLL (mobile)
  ========================================================= */
  function initSkuDrag() {
    qsa('.support-sku-grid').forEach(function (grid) {
      var isDown = false, startX, scrollLeft;
      grid.addEventListener('mousedown', function (e) {
        isDown = true;
        grid.style.cursor = 'grabbing';
        startX = e.pageX - grid.offsetLeft;
        scrollLeft = grid.scrollLeft;
      });
      grid.addEventListener('mouseleave', function () { isDown = false; grid.style.cursor = 'grab'; });
      grid.addEventListener('mouseup', function () { isDown = false; grid.style.cursor = 'grab'; });
      grid.addEventListener('mousemove', function (e) {
        if (!isDown) return;
        e.preventDefault();
        var x = e.pageX - grid.offsetLeft;
        grid.scrollLeft = scrollLeft - (x - startX) * 1.4;
      });
    });
  }

  /* =========================================================
     FAQ ACCORDION
  ========================================================= */
  function initFaq() {
    qsa('.faq-question').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var item = btn.closest('.faq-item');
        if (!item) return;
        var isOpen = item.classList.contains('open');
        // close all in same list
        var list = item.closest('.faq-list');
        if (list) {
          qsa('.faq-item', list).forEach(function (i) { i.classList.remove('open'); });
        }
        if (!isOpen) item.classList.add('open');
      });
    });
  }

  /* =========================================================
     FAQ SEARCH FILTER
  ========================================================= */
  function initFaqSearch() {
    var input = qs('.support-faq-tools input');
    if (!input) return;
    input.addEventListener('input', function () {
      var val = input.value.trim().toLowerCase();
      qsa('.faq-item').forEach(function (item) {
        var text = item.textContent.toLowerCase();
        item.style.display = (!val || text.includes(val)) ? '' : 'none';
      });
    });
  }

  /* =========================================================
     SUPPORT HUB → ENTRY PAGE ROUTING
  ========================================================= */
  var currentEntry = null;

  function getHeaderHeight() {
    var header = qs('.qs-header') || qs('header');
    return header ? header.offsetHeight : 70;
  }

  function showEntry(id) {
    // hide hub
    document.body.classList.add('support-detail-active');

    // hide all entry pages
    qsa('.support-entry-page').forEach(function (p) { p.classList.remove('active'); });

    // show target
    var page = qs('#' + id);
    if (page) {
      page.classList.add('active');
      currentEntry = id;
      window.scrollTo({ top: 0, behavior: 'smooth' });

      // update URL hash without reload
      if (history.pushState) {
        history.pushState(null, '', '#' + id);
      }

      // re-init TOC for policy / product pages
      setTimeout(function () {
        initToc();
        initProductToc();
        updateHeaderOffset();
      }, 80);
    }
  }

  function showHub() {
    document.body.classList.remove('support-detail-active');
    qsa('.support-entry-page').forEach(function (p) { p.classList.remove('active'); });
    currentEntry = null;
    window.scrollTo({ top: 0, behavior: 'smooth' });
    if (history.pushState) {
      history.pushState(null, '', window.location.pathname);
    }
  }

  function initRouting() {
    // Cards that link to entry pages
    qsa('[data-support-entry]').forEach(function (el) {
      el.addEventListener('click', function (e) {
        e.preventDefault();
        var target = el.getAttribute('data-support-entry');
        if (target) showEntry(target);
      });
      el.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          var target = el.getAttribute('data-support-entry');
          if (target) showEntry(target);
        }
      });
    });

    // Back links inside entry pages
    qsa('.support-back-link').forEach(function (link) {
      link.addEventListener('click', function (e) {
        e.preventDefault();
        showHub();
      });
    });

    // Product tiles → product detail page
    qsa('[data-support-product]').forEach(function (el) {
      el.addEventListener('click', function (e) {
        e.preventDefault();
        var productId = el.getAttribute('data-support-product');
        loadProductDetail(productId);
      });
    });

    // Handle browser back/forward
    window.addEventListener('popstate', function () {
      var hash = window.location.hash.replace('#', '');
      if (hash) {
        showEntry(hash);
      } else {
        showHub();
      }
    });

    // On load, check hash
    var initHash = window.location.hash.replace('#', '');
    if (initHash) {
      var target = qs('#' + initHash);
      if (target && target.classList.contains('support-entry-page')) {
        showEntry(initHash);
      }
    }
  }

  /* =========================================================
     PRODUCT DETAIL LOADER
  ========================================================= */
  var productData = {};

  function registerProduct(id, data) {
    productData[id] = data;
  }

  function loadProductDetail(productId) {
    var detailPage = qs('#product-support-detail');
    if (!detailPage) return;

    var data = productData[productId];
    if (!data) return;

    // Populate title / tag / image
    var titleEl = detailPage.querySelector('.support-product-title');
    var tagEl = detailPage.querySelector('.support-product-tag');
    var imgEl = detailPage.querySelector('.support-product-image img');

    if (titleEl) titleEl.textContent = data.title || '';
    if (tagEl) tagEl.textContent = data.tag || '';
    if (imgEl) {
      imgEl.src = data.image || '';
      imgEl.alt = data.title || '';
    }

    // Populate spec table
    var specTable = detailPage.querySelector('.support-spec-table tbody');
    if (specTable && data.specs) {
      specTable.innerHTML = '';
      data.specs.forEach(function (row) {
        var tr = document.createElement('tr');
        tr.innerHTML = '<th>' + row[0] + '</th><td>' + row[1] + '</td>';
        specTable.appendChild(tr);
      });
    }

    // Populate downloads
    var dlList = detailPage.querySelector('.support-download-list');
    if (dlList && data.downloads) {
      dlList.innerHTML = '';
      data.downloads.forEach(function (dl) {
        var row = document.createElement('div');
        row.className = 'support-download-row';
        row.innerHTML =
          '<div><h4>' + dl.name + '</h4></div>' +
          '<span>' + (dl.type || 'PDF') + '</span>' +
          '<a href="' + (dl.url || '#') + '" class="support-download-action" target="_blank" rel="noopener">Download</a>';
        dlList.appendChild(row);
      });
    }

    // Show the detail entry page
    showEntry('product-support-detail');
  }

  /* =========================================================
     STICKY TOC — POLICY PAGES
  ========================================================= */
  function initToc() {
    var toc = qs('.shipping-policy-toc');
    if (!toc) return;
    var links = qsa('.shipping-toc-link', toc);
    var sections = links.map(function (link) {
      var id = link.getAttribute('data-toc-target');
      return id ? qs('#' + id) : null;
    }).filter(Boolean);

    if (!sections.length) return;

    function onScroll() {
      var offset = getHeaderHeight() + 80;
      var current = sections[0];
      sections.forEach(function (sec) {
        if (window.scrollY + offset >= sec.offsetTop) current = sec;
      });
      links.forEach(function (link) {
        link.classList.toggle('is-active', link.getAttribute('data-toc-target') === current.id);
      });
    }

    // TOC click smooth scroll
    links.forEach(function (link) {
      link.addEventListener('click', function (e) {
        e.preventDefault();
        var id = link.getAttribute('data-toc-target');
        var target = qs('#' + id);
        if (target) {
          var offset = getHeaderHeight() + 60;
          var top = target.getBoundingClientRect().top + window.scrollY - offset;
          window.scrollTo({ top: top, behavior: 'smooth' });
        }
      });
    });

    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* =========================================================
     STICKY TOC — PRODUCT DETAIL PAGE
  ========================================================= */
  function initProductToc() {
    var toc = qs('.support-product-toc');
    if (!toc) return;
    var links = qsa('.shipping-toc-link', toc);
    var sections = links.map(function (link) {
      var id = link.getAttribute('data-toc-target');
      return id ? qs('#' + id) : null;
    }).filter(Boolean);

    if (!sections.length) return;

    function onScroll() {
      var offset = getHeaderHeight() + 100;
      var current = sections[0];
      sections.forEach(function (sec) {
        if (window.scrollY + offset >= sec.offsetTop) current = sec;
      });
      links.forEach(function (link) {
        link.classList.toggle('is-active', link.getAttribute('data-toc-target') === current.id);
      });
    }

    links.forEach(function (link) {
      link.addEventListener('click', function (e) {
        e.preventDefault();
        var id = link.getAttribute('data-toc-target');
        var target = qs('#' + id);
        if (target) {
          var offset = getHeaderHeight() + 80;
          var top = target.getBoundingClientRect().top + window.scrollY - offset;
          window.scrollTo({ top: top, behavior: 'smooth' });
        }
      });
    });

    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* =========================================================
     UPDATE CSS CUSTOM PROPERTY FOR HEADER OFFSET
  ========================================================= */
  function updateHeaderOffset() {
    var h = getHeaderHeight();
    document.documentElement.style.setProperty('--support-header-offset', h + 'px');
  }

  /* =========================================================
     POLICY TOC DRAG SCROLL (mobile pill nav)
  ========================================================= */
  function initTocDrag() {
    qsa('.shipping-policy-toc nav, .support-product-toc nav').forEach(function (nav) {
      var isDown = false, startX, scrollLeft;
      nav.addEventListener('mousedown', function (e) {
        isDown = true;
        startX = e.pageX - nav.offsetLeft;
        scrollLeft = nav.scrollLeft;
      });
      nav.addEventListener('mouseleave', function () { isDown = false; });
      nav.addEventListener('mouseup', function () { isDown = false; });
      nav.addEventListener('mousemove', function (e) {
        if (!isDown) return;
        e.preventDefault();
        nav.scrollLeft = scrollLeft - (e.pageX - nav.offsetLeft - startX) * 1.2;
      });
    });
  }

  /* =========================================================
     NEWSLETTER FORM
  ========================================================= */
  function initNewsletter() {
    var form = qs('.newsletter form');
    if (!form) return;
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var input = form.querySelector('input[type="email"]');
      var btn = form.querySelector('button[type="submit"]');
      if (!input || !input.value.trim()) return;
      if (btn) btn.textContent = 'Subscribed ✓';
      input.value = '';
      input.disabled = true;
      if (btn) btn.disabled = true;
    });
  }

  /* =========================================================
     SUPPORT FORM SUBMIT (warranty / contact)
  ========================================================= */
  function initSupportForms() {
    qsa('.support-form').forEach(function (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        form.classList.add('is-submitted');
        var btn = form.querySelector('.support-submit');
        if (btn) btn.textContent = 'Submitted ✓';
        // scroll to note
        var note = form.querySelector('.support-form-note');
        if (note) {
          setTimeout(function () {
            note.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
          }, 120);
        }
      });
    });
  }

  /* =========================================================
     MEASURE STICKY BACK-LINK HEIGHT (for CSS var)
  ========================================================= */
  function measureStickyBars() {
    // product detail back link
    var productBack = qs('#product-support-detail > .container > .support-back-link');
    if (productBack) {
      document.documentElement.style.setProperty(
        '--support-product-back-height',
        productBack.offsetHeight + 'px'
      );
    }
    // policy back link
    var policyBack = qs('.shipping-policy-page > .container > .support-back-link');
    if (policyBack) {
      document.documentElement.style.setProperty(
        '--support-policy-back-height',
        policyBack.offsetHeight + 'px'
      );
    }
    // policy toc height
    var policyToc = qs('.shipping-policy-toc');
    if (policyToc) {
      document.documentElement.style.setProperty(
        '--support-policy-toc-height',
        policyToc.offsetHeight + 'px'
      );
    }
  }

  /* =========================================================
     INIT ALL
  ========================================================= */
  function init() {
    updateHeaderOffset();
    initReveal();
    initCatTabs();
    initSkuDrag();
    initFaq();
    initFaqSearch();
    initRouting();
    initToc();
    initProductToc();
    initTocDrag();
    initNewsletter();
    initSupportForms();
    measureStickyBars();

    window.addEventListener('resize', function () {
      updateHeaderOffset();
      measureStickyBars();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Shopify section reload support
  document.addEventListener('shopify:section:load', function () {
    init();
  });

  // Expose registerProduct globally for Liquid to call
  window.QlearSupportRegisterProduct = registerProduct;

})();